import { Button, Checkbox, Col, DatePicker, Form, Input, InputNumber, Pagination, Radio, Row, Select, Space, Table, Tabs } from 'antd';
import React, { useEffect, useState } from 'react';
import { Link, useLoaderData, useNavigate, useOutletContext } from 'react-router-dom';
import EventEmitter from '../../utils/eventEmitter';
import GoBack from '../../globalComponents/GoBack';

const columns = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '20%'
  },
  {
    title: 'Contact',
    dataIndex: 'contact',
    key: 'contact',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '20%'
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '20%'
  },
  {
    title: 'Phone',
    dataIndex: 'phone',
    key: 'phone',
    className: 'whitespace-nowrap font-medium text-[#189aa0] dark:text-white',
    width: '20%'
  },
  {
    title: 'Action',
    key: 'operation',
    width: '20%',
    // fixed: 'right',
    className: 'whitespace-nowrap font-medium text-dark-600 dark:text-white',
    render: (_, record) => (
      <Link className='h-full w-full' to={'/pos/session/sells/customers/'+record.seo}>
        EDIT
      </Link>
    )
  }
]




const PosSessionCustomers = () => {
  const customers = useLoaderData();
  const navigate = useNavigate();
  // const { order } = useOutletContext();
  const [searchedCustomers, setSearchedCustomers] = useState([]);


  const onRow = (record, rowIndex) => {
    return {
      onClick: () => EventEmitter.dispatch('posordercontactselected', {id: record.id, cus_name: record.name, cus_phone: record.phone})
    };
  }

  // useEffect(() => {
  //   console.log('HIT')
  // },[])

  const handleSearch = (e) => {
    let debounceTimeout = null;
    let search = e.target.value;
    if (debounceTimeout) {
      clearTimeout(debounceTimeout);
    }
    debounceTimeout = setTimeout(() => {
      if (search.length > 0) {
        const searchedCustomers_ = customers.filter(product =>
          product.name.toLowerCase().includes(search.toLowerCase()) ||
          String(product.phone).includes(String(search))
        );
        if (searchedCustomers_.length > 0) {
          setSearchedCustomers(searchedCustomers_);
        }
      }else {
        setSearchedCustomers([]);
      }
    }, 700);
  }

  const hanldeCreate = () => {
    navigate('/pos/session/sells/customers/new');
  }

  const handleKeyboardInput = (event) => {
    const key = event.key;
    
    // Check if the key is a number (0-9) or decimal point (.)
    if (event.ctrlKey || event.key === 'Control' || event.key === 'Fn') {
      // event.preventDefault(); // Prevent default behavior of these keys
      console.log("Ctrl or Fn key pressed, action prevented.");
    }else {
      if (/[0-9]/.test(key)) {

        console.log(key)
      }
        // Check for Enter key to trigger calculation
      else if (key === "Enter") {
        // handleOk();
        console.log('enter pressed');
      }
      // Check for backspace key to clear the last character (delete)
      else if (key === "Backspace") {

        console.log('backspace pressed');
      }
      // Check for Escape key to clear the display
      else if (key === "Escape") {
        // resetPasscode();
          console.log('esc pressed');
      }
    }
  };



  return (
    <div>
      <GoBack />
      <div className='flex justify-between'>
        <Button onClick={hanldeCreate}>Create</Button>
        <div className='flex justify-end w-1/2' style={{border: '1px solid lightgray'}}>
          <Input type='text' id='customer-search' onChange={handleSearch} className='input-outline-none' placeholder='search customer' />
        </div>
      </div>
      <Table
        sticky
        key={'name'}
        onRow={onRow}
        rowClassName={'hover:cursor-pointer'}
        dataSource={searchedCustomers.length > 0 ? searchedCustomers : customers}
        columns={columns}
        // scroll={{ x: 1500 }}
        pagination={false}
      />
    
    </div>
  )
}

export default PosSessionCustomers;